package team.platforma.auth_presentable.viewModel

import androidx.lifecycle.ViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class ConfirmEmailViewModel() : ViewModel() {
    private val singletonScope = CoroutineScope(Dispatchers.Main + SupervisorJob())

    private var emailRequestedCode = ""

    fun requestCode(email: String, onSuccess: () -> Unit, onFail: () -> Unit) {
        emailRequestedCode = email
        //Do request here
        //Start timer
        startTimer()
    }

    private val _emailIsConfirmed: MutableStateFlow<Boolean> = MutableStateFlow(false)
    val emailIsConfirmed: StateFlow<Boolean> = _emailIsConfirmed

    fun confirmPhone(
        smsCode: String,
        onSuccess: () -> Unit,
        onFail: (message: String, code: Int) -> Unit
    ) {
        //Add request here with mail
       // email = emailRequestedCode,

        confirmedCode = smsCode
        if (smsCode == "111111") {
            _emailIsConfirmed.value = true
            onSuccess.invoke()
        }
    }

    private var confirmedCode = ""
    private val _codeRequestTimer: MutableStateFlow<CodeRequestTimer> = MutableStateFlow(
        CodeRequestTimer(isCountdown = false, timer = "", visible = false)
    )
    val codeRequestTimer: StateFlow<CodeRequestTimer> = _codeRequestTimer

    private val countdownTimer = CountdownTimer(
        totalMillis = 2 * 60 * 1000L
    )

    fun confirmedCode(): String {
        return confirmedCode
    }

    private fun startTimer() {
        countdownTimer.start(singletonScope) { time, isCountdown ->
            _codeRequestTimer.value = CodeRequestTimer(
                isCountdown = isCountdown,
                timer = time,
                visible = true
            )
        }
    }

    fun stopSmsTimer() {
        countdownTimer.stop()
        _codeRequestTimer.value = CodeRequestTimer(
            isCountdown = false,
            timer = "",
            visible = false
        )
    }

    fun clearViewModel() {
        emailRequestedCode = ""

        _emailIsConfirmed.value = false

        confirmedCode = ""
    }
}

data class CodeRequestTimer(
    val isCountdown: Boolean,
    val timer: String,
    val visible: Boolean
)

class CountdownTimer(
    private val totalMillis: Long,
    private val intervalMillis: Long = 1000L
) {

    private var timerJob: Job? = null

    fun start(scope: CoroutineScope, timer: (time: String, isCountdown: Boolean) -> Unit) {
        timerJob = scope.launch {
            var remainingMillis = totalMillis

            while (remainingMillis >= 0) {
                val minutes = remainingMillis / 60000
                val seconds = (remainingMillis / 1000) % 60

                val formattedTime = if (minutes > 0) {
                    "$minutes:${seconds.toString().padStart(2, '0')}"
                } else {
                    seconds.toString().padStart(2, '0')
                }

                timer(formattedTime, true)
                delay(intervalMillis)
                remainingMillis -= intervalMillis
            }
            timer("", false)
            timerJob?.cancel()
        }
    }

    fun stop() {
        timerJob?.cancel()
        timerJob = null
    }


}